export default __webpack_public_path__ + "static/media/coin-toolbox-red.5945701e.jpg";